var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    viewBox: "0 0 22 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9800",
    d: "m11 12.492 6.903 11.925H4.098zm0-3.658L.917 26.251h20.166zm.917 12.833h-1.834v1.834h1.834zm0-5.5h-1.834v3.667h1.834z"
  })));
};
export default SvgAlert;